<div class="torre-control-transporte-page">
    <!-- Header de página -->
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">TORRE CONTROL TRANSPORTE</h1>
                <p class="page-subtitle text-muted">
                    Panel de monitoreo en tiempo real de contenedores en tránsito
                </p>
            </div>
            <a [href]="torreControlUrl" target="_blank" rel="noopener noreferrer" mat-button color="primary">
                Abrir en nueva pestaña
                <i class="ri-external-link-line ms-1"></i>
            </a>
        </div>
    </div>

    <!-- Mensaje de error al obtener token -->
    <div *ngIf="tokenError" class="token-error mb-3">
        <p class="text-warning mb-0">{{ tokenError }}</p>
    </div>

    <!-- Cargando token -->
    <div *ngIf="loadingToken" class="iframe-container iframe-loading d-flex align-items-center justify-content-center">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="ms-2">Obteniendo acceso a Torre de Control...</span>
    </div>

    <!-- iframe con la Torre de Control externa (cuando ya hay URL con token) -->
    <div *ngIf="!loadingToken" class="iframe-container">
        <iframe
            [src]="torreControlSafeUrl"
            title="OPB Torre de Control"
            class="torre-control-iframe"
        ></iframe>
    </div>
</div>
